<mat-card
  class="library-card"
  [class.library-card-small]="tileSize === 'small'"
  [class.library-card-medium]="tileSize === 'medium'"
  [class.library-card-large]="tileSize === 'large'"
  [class.bulk-edit-selected]="bulkEditMode && isSelected"
>
  <!-- Checkbox overlay in upper-right corner -->
  <div *ngIf="bulkEditMode" class="bulk-edit-checkbox-wrapper">
    <mat-checkbox
      [checked]="isSelected"
      (change)="onSelectionToggle()"
      (click)="$event.stopPropagation()"
    >
    </mat-checkbox>
  </div>

  <div class="cover-frame" (click)="onCoverClick()" style="cursor: pointer;">
    <img
      #coverImage
      class="cover"
      [src]="currentCoverUrl"
      (error)="onCoverError($event)"
      [alt]="book.title + ' cover'"
    />
  </div>
  <div class="info">
    <div class="title">{{ book.title }}</div>
    <div class="personal-stars" aria-label="Personal rating">
      <button
        *ngFor="let star of starRange"
        type="button"
        class="star-button"
        [class.filled]="(book.personalRating ?? 0) >= star"
        (click)="setPersonalRating(star)"
      >
        ★
      </button>
    </div>
    <div class="author" [class.author-missing]="book.authors.length === 0">
      {{ book.authors.length ? book.authors.join(', ') : '' }}
    </div>
    <div class="meta">{{ book.format }} &nbsp;|&nbsp; {{ book.fileSize }}</div>
    <div class="goodreads-row">
      <button
        type="button"
        class="bookmark-btn"
        [class.bookmarked]="book.bookmarked"
        (click)="onBookmarkToggle()"
        aria-label="Toggle bookmark"
      >
        <mat-icon>{{ book.bookmarked ? 'bookmark' : 'bookmark_border' }}</mat-icon>
      </button>
      <div class="goodreads">
        Goodreads
        <span class="goodreads-value">
          {{ book.goodreadsRating !== null && book.goodreadsRating !== undefined
            ? (book.goodreadsRating | number:'1.1-1')
            : 'NA' }}
        </span>
      </div>
    </div>
  </div>
  <div class="card-actions">
    <button
      mat-raised-button
      color="primary"
      (click)="onSendToKindle('dad')"
      [disabled]="!book.fileName || !canSendToKindle || book.dadsKindleState === 'sending'">
      <ng-container [ngSwitch]="book.dadsKindleState">
        <span *ngSwitchCase="'sending'">Sending…</span>
        <span *ngSwitchCase="'success'">✔ Sent</span>
        <span *ngSwitchCase="'error'">✖ Retry</span>
        <ng-container *ngSwitchDefault>
          <span class="kindle-btn-full">Dad's Kindle</span>
          <span class="kindle-btn-compact"><mat-icon>send</mat-icon>D</span>
        </ng-container>
      </ng-container>
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSendToKindle('mom')"
      [disabled]="!book.fileName || !canSendToKindle || book.momsKindleState === 'sending'">
      <ng-container [ngSwitch]="book.momsKindleState">
        <span *ngSwitchCase="'sending'">Sending…</span>
        <span *ngSwitchCase="'success'">✔ Sent</span>
        <span *ngSwitchCase="'error'">✖ Retry</span>
        <ng-container *ngSwitchDefault>
          <span class="kindle-btn-full">Mom's Kindle</span>
          <span class="kindle-btn-compact"><mat-icon>send</mat-icon>M</span>
        </ng-container>
      </ng-container>
    </button>
  </div>
</mat-card>
